// assets
import { IconBell, IconTemplate, IconMessages, IconAdjustments } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - NOTIFICATIONS (A4) ||============================== //
// Bildirimler: platform olaylarından türeyen gelen kutusu + versiyonlu şablonlar.

const notifications: NavItemType = {
  id: 'notifications',
  title: 'notifications', // react-intl key (utils/locales/en.json) - i18n-ready [STD-DRIFT]
  icon: IconBell,
  type: 'group',
  requiredModule: 'notification',
  children: [
    {
      id: 'notifications-inbox',
      title: 'notifications-inbox',
      icon: IconBell,
      type: 'item',
      url: '/notifications/inbox',
      module: 'notif.inbox'
    },
    {
      id: 'notifications-templates',
      title: 'notifications-templates',
      icon: IconTemplate,
      type: 'item',
      url: '/notifications/templates',
      module: 'notif.templates'
    },
    {
      id: 'notifications-discuss',
      title: 'notifications-discuss',
      icon: IconMessages,
      type: 'item',
      url: '/notifications/discuss',
      module: 'notif.discuss'
    },
    {
      id: 'notifications-preferences',
      title: 'notifications-preferences',
      icon: IconAdjustments,
      type: 'item',
      url: '/notifications/preferences',
      module: 'notif.preferences'
    }
  ]
};

export default notifications;
